import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getStringLenth } from '@src/utils/index';

const FormTextarea = ({ name, formData, placeholder, changeInputHandle, limitWord, updateSuccess }) => {
    const [text, setText] = useState(formData?.[name] || '');
    const [textNum, setTextNum] = useState(0);
    const [isRedSize, setIsRedSize] = useState(false);
    const changeHandle = (event) => {
        const changeText = event.target.value;

        setText(event.target.value);
        changeInputHandle(name, event.target.value);
        setTextNum(getStringLenth(changeText));
    };

    useEffect(() => {
        setTextNum(getStringLenth(formData?.[name]));
    }, [updateSuccess]);

    useEffect(() => {
        if (getStringLenth(text) > limitWord) {
            setIsRedSize(true);
        } else {
            setIsRedSize(false);
        }
    }, [text, textNum, updateSuccess]);

    return (
        <div className={styles.formTextareaBox}>
            <textarea onChange={changeHandle} value={text || formData?.[name] || ''} className={styles.formTextarea} placeholder={placeholder || ''} />
            {limitWord ? (
                <div className={styles.formTextareaWord}>
                    <span className={isRedSize ? styles.redSize : {}}>{textNum}</span>/{limitWord}
                </div>
            ) : null}
        </div>
    );
};

FormTextarea.propTypes = {
    name: PropTypes.string,
    formData: PropTypes.object,
    placeholder: PropTypes.string,
    limitWord: PropTypes.number,
    changeInputHandle: PropTypes.func,
    updateSuccess: PropTypes.bool,
};

export default errorBoundary(FormTextarea);
